import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';

export const uploadFiles = createAsyncThunk(
    'files/uploadFiles',
    async (formData, { rejectWithValue }) => {
        try {
            const response = await apiService.uploadFiles(formData);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to upload file');
        }
    }
);

const initialState = {
    uploadedFiles: [],
    uploadLoading: false,
    error: null,
};

const fileSlice = createSlice({
    name: 'files',
    initialState,
    reducers: {
        clearUploadedFiles: (state) => {
            state.uploadedFiles = [];
        },
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(uploadFiles.pending, (state) => {
                state.uploadLoading = true;
                state.error = null;
            })
            .addCase(uploadFiles.fulfilled, (state, action) => {
                state.uploadLoading = false;
                state.uploadedFiles = action.payload?.data
                state.error = null;
            })
            .addCase(uploadFiles.rejected, (state, action) => {
                state.uploadLoading = false;
                state.error = action.payload;
            });
    },
});

export const { clearUploadedFiles, clearError } = fileSlice.actions;

export default fileSlice.reducer;
